import { useNavigate } from 'react-router-dom'
import { useState, useEffect } from 'react';
import AdQuestion from '../components/question/ADquestion';

export const AdditionalQuestions: Record<string, Record<string, string[]>> = {
    RequiredCover_ID: {
        "AccDmgBldgCvrYN": ["BC", "BO"],
        "AccDmgContCvrYN": ["BC", "CO"]
    }
    //Example of a question that's moved to Ad questions that doesn't have an enablement criteria
    //TenAgmtMin6MoYN: {}
};

const getQuestionByAnswerFieldName= (answerFieldName: string, questions: any[]) => {
    return questions.find((question: any) =>
        question.questionSetQuestion.answerFieldName === answerFieldName
    );
};

export const GetMatchingAdQuestionsFromQuestionSet = (questions: any[]) => {
    const allParentQuestionAnswerFieldNames = Object.keys(AdditionalQuestions)
    var adQuestions = [];
    const matchingParentAnswerFieldNames = allParentQuestionAnswerFieldNames.filter(answerFieldName => questions.some((question: any) => question.questionSetQuestion.answerFieldName === answerFieldName));


    for (const parentAnswerFieldName of matchingParentAnswerFieldNames) {
        const parentQuestion = getQuestionByAnswerFieldName(parentAnswerFieldName, questions)
        if (Object.keys(AdditionalQuestions[parentAnswerFieldName]).length === 0) {
            adQuestions.push(parentQuestion);
        }
        else {
            for (const childAnswerFieldName of Object.keys(AdditionalQuestions[parentAnswerFieldName])) {
                let enablementAnswers = Object.values(AdditionalQuestions[parentAnswerFieldName]?.[childAnswerFieldName])
                if (enablementAnswers.some((answer) => parentQuestion.answer === answer)) {
                    adQuestions.push(getQuestionByAnswerFieldName(childAnswerFieldName, questions))
                }
            }
        }
    }
    return adQuestions;
};

export const isAdQuestion = (question: any) => {
    let allAdAnswerFieldNames = [];
    const allParentQuestionAnswerFieldNames = Object.keys(AdditionalQuestions);
    for (const parentFieldName of allParentQuestionAnswerFieldNames) {
        if (Object.keys(AdditionalQuestions[parentFieldName]).length === 0) {
            allAdAnswerFieldNames.push(parentFieldName);
        }
        else {
            for (const childFieldName of Object.keys(AdditionalQuestions[parentFieldName])) {
                allAdAnswerFieldNames.push(childFieldName);
            }
        }
    }
    return allAdAnswerFieldNames.some((answerFieldName) => question.questionSetQuestion.answerFieldName === answerFieldName)
}

export default function AdQuestions() {
    const navigate = useNavigate();
    const [questions, setQuestions] = useState<any[]>([]);
    let adQuestions = GetMatchingAdQuestionsFromQuestionSet(questions);
    useEffect(() => {
        setQuestions(JSON.parse(localStorage.getItem('questions') || "[]"));
    }, [])

    const updateAnswerByFieldName = (answerFieldName: string, newAnswer: string) => {
        const updatedQuestions = questions.map((question: any) => {
            if (question.questionSetQuestion.answerFieldName === answerFieldName) {
                return {
                    ...question,
                    answer: newAnswer
                };
            }

            return question;
        });

        localStorage.setItem("questions", JSON.stringify(updatedQuestions));

        navigate("/Loading", {
            state: {
                pageToLoad: "/YourQuotes",
                loadingTitle: "Updating your quotes",
                loadingMessage: "Please wait while we update your quotes."
            }
        });
    };

    return (
        <>
            {adQuestions.map((adQuestion: any) => (
                <AdQuestion adQuestion={adQuestion} updateAnswerByFieldName={updateAnswerByFieldName} />
            ))}
        </>
    )
    
}
